import {
  CommonButton,
  ImageElement,
  ModalComponent,
  RippleEffect,
  SweetAlert,
} from "components/UiElement";
import { Container, Nav, Navbar } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Link as ScrollLink } from "react-scroll";
import routesMap from "routeControl/userRouteMap";
import { useState, useMemo } from "react";
import ShareBiographyForm from "components/Form/User/ShareBiographyForm/index.form";
import WebShare from "components/UiElement/Share";
import DropDownComponent from "components/UiElement/DropDownComponent";
import {
  decoder,
  encoder,
  logger,
  modalNotification,
  setSessionStorage,
} from "utils";
import { MyBiographiesServices } from "services";
import { useSelector } from "react-redux";
import { selectUserData } from "redux/AuthSlice/index.slice";
import { textFormatter } from "components/Formatter";

function ThemeNavbar({
  isScrolled,
  offset,
  memorialData,
  isUser,
  handleCloseModal,
  setShareModal,
  shareModal,
  handleDelete,
  t,
  getMemorialData,
  isModal,
  capturedData,
  familyTreeData,
  timelineData,
}) {
  const [isAlertVisible, setIsAlertVisible] = useState(false);
  const { id } = useParams();
  const userData = useSelector(selectUserData);
  const isEmail = textFormatter(userData?.email);
  const navigate = useNavigate();
  const [publishAlert, setPublishAlert] = useState(false);
  const [publishedId, setPublishedId] = useState("");

  const onHandlePublished = (publishId) => {
    setPublishAlert(true);
    setPublishedId(publishId);
  };

  const userId = userData?.id;

  const onPublish = async (publishId) => {
    try {
      const res = await MyBiographiesServices?.biographyPublish(publishId);
      const { success, message } = res;
      if (success) {
        modalNotification({ type: "success", message });
        getMemorialData("theme04");
        setPublishedId("");
      }
    } catch (error) {
      logger(error);
    }
  };

  const isEdits = useMemo(() => {
    const specificEmail = memorialData?.memorialUserPermissions?.find(
      (item) => {
        return textFormatter(item?.email) === isEmail;
      }
    );
    return specificEmail;
  }, [memorialData, isEmail]);

  const dorpDowns = () => {
    let arr = [];
    if (
      (isEdits?.edit === 1 &&
        memorialData?.memorialUserPermissions?.length > 0) ||
      memorialData?.userId === userId
    ) {
      arr.splice(0, 0, {
        name: t("text.common.edit"),
        onClicks: () => {
          navigate(
            `${routesMap?.CREATEMEMORIALS?.path}/${encoder(
              memorialData?.id
            )}?${encoder(memorialData?.themeOnes?.[0]?.type)}`
          );
          setSessionStorage("steps", 1);
          setSessionStorage(
            "theme",
            memorialData?.themeOnes?.[0]?.type || "theme02"
          );
        },
        icon: "icon-edit",
        theme: "theme01",
      });
    }
    if (memorialData?.userId !== userId) {
      arr.splice(1, 1, {
        name: memorialData?.isSaved === false ? "Save" : "Unsave",
        onClicks: () => {
          setIsAlertVisible(true);
        },
        icon: "icon-saved",
      });
    }
    if (memorialData?.status !== "published") {
      arr.splice(2, 0, {
        name: t("text.common.close"),
        path: routesMap?.MYBIOGRAPHIES?.path,
        icon: "icon-close",
      });
    }
    return arr;
  };

  const [isCopy, setIsCopy] = useState(false);

  function getCurrentURL() {
    return window.location.href;
  }
  const url = getCurrentURL();

  return (
    <>
      <header className={`theme04Header ${isScrolled ? "scrolled" : ""}`}>
        <Navbar expand="lg" className="p-0">
          <Container>
            <div className="d-flex align-items-center justify-content-between w-100">
              <div>
                <Link
                  to={
                    isModal || !isUser
                      ? routesMap.HOME.path
                      : routesMap.USERDASHBOARD.path
                  }
                  className={`p-0 me-0 navbar-brand ${isScrolled ? "d-none" : "d-block"}`}
                >
                  <ImageElement
                    source="white-logo.svg"
                    alt="logo"
                    className="w-100 img-fluid"
                  />
                </Link>
                <Link
                  to={
                    isModal || !isUser
                      ? routesMap.HOME.path
                      : routesMap.USERDASHBOARD.path
                  }
                  className={`p-0 me-0 ${isScrolled ? "d-block" : "d-none"}`}
                >
                  <ImageElement
                    source="logo.svg"
                    alt="logo"
                    className="w-100"
                  />
                </Link>
              </div>
              <div className="d-flex align-items-center">
                {!isModal && (
                  <Navbar.Toggle
                    aria-controls="navbarScroll"
                    className="order-3"
                  >
                    <em className="icon-menu" />
                  </Navbar.Toggle>
                )}
                {/* <div> */}
                {!isModal && (
                  <Navbar.Collapse id="navbarScroll">
                    <Nav className="ms-auto my-lg-0" navbarScroll>
                      <ScrollLink
                        activeClass="active"
                        className="nav-link"
                        to="about"
                        spy
                        smooth
                        offset={-offset}
                        duration={500}
                      >
                        {t("text.common.about")}
                      </ScrollLink>
                      {capturedData?.length > 0 && (
                        <ScrollLink
                          activeClass="active"
                          className="nav-link"
                          to="gallery"
                          spy
                          smooth
                          offset={-offset}
                          duration={500}
                        >
                          {t("text.theme.gallery")}
                        </ScrollLink>
                      )}
                      {timelineData?.length > 0 && (
                        <ScrollLink
                          activeClass="active"
                          className="nav-link"
                          to="timeline"
                          spy
                          smooth
                          offset={-offset}
                          duration={500}
                        >
                          {t("text.theme.timeline")}
                        </ScrollLink>
                      )}
                      <ScrollLink
                        activeClass="active"
                        className="nav-link"
                        to="story"
                        spy
                        smooth
                        offset={-offset}
                        duration={500}
                      >
                        {t("text.theme.story")}
                      </ScrollLink>
                      {familyTreeData?.length > 0 && (
                        <ScrollLink
                          activeClass="active"
                          className="nav-link"
                          to="familytree"
                          spy
                          smooth
                          offset={-offset}
                          duration={500}
                        >
                          {t("text.theme.familyTree")}
                        </ScrollLink>
                      )}
                    </Nav>
                  </Navbar.Collapse>
                )}
                {/* </div> */}
                {isUser && (
                  <>
                    {!isModal && (
                      <DropDownComponent
                        items={dorpDowns()}
                        theme="theme04"
                        centerClass="btnCenter me-md-3 me-2"
                        menuClass="border-0 p-0 rounded"
                        extraClassName="rounded"
                        size="sm"
                      />
                    )}
                    {userId === memorialData?.userId &&
                    memorialData?.status !== "published" &&
                    !isModal ? (
                      <RippleEffect extraClassName="justify-content-end me-md-3 me-2">
                        <CommonButton
                          variant="danger"
                          size="sm"
                          className="rounded w-auto"
                          onClick={() => {
                            if (memorialData?.status !== "published")
                              onHandlePublished(memorialData?.id);
                          }}
                        >
                          <span>Publish</span>
                        </CommonButton>
                      </RippleEffect>
                    ) : (
                      <>
                      <RippleEffect extraClassName="justify-content-end me-md-3 me-2">
                        <CommonButton
                          variant="danger"
                          size="sm"
                          className="rounded"
                          onClick={() => setShareModal(true)}
                        >
                          <em className="icon-share me-sm-2" />
                          <span className="d-none d-sm-block">
                            {t("text.common.share")}
                          </span>
                        </CommonButton>
                      </RippleEffect>
                      
                      {/* back btn */}
                      {/* <RippleEffect extraClassName="justify-content-end">
                  <CommonButton
                    variant="outline-white" size="sm" className="rounded"
                  >
                    <em className="icon-arrow-prev me-sm-2" />
                    <span className="d-none d-sm-block">Back</span>
                  </CommonButton>
                </RippleEffect> */}
                      </>
                    )}
                  </>
                )}
                {/* <Dropdown className="d-flex justify-content-center align-items-center actionDropdown btnCenter me-md-3 me-2">
                  <Dropdown.Toggle variant="white"  size="sm" className="rounded">
                        <span className="text-dark">Action</span>
                        <em className="icon-arrow-down ms-sm-2 d-none d-sm-block text-dark" />
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="border-0 p-0 rounded">
                    <Dropdown.Item href="#/action-1" className="d-flex align-items-center">
                    <em className="icon-edit me-2" /> Edit
                    </Dropdown.Item>
                    <Dropdown.Item href="#/action-1" className="d-flex align-items-center">
                    <em className="icon-saved me-2" /> Save as Draft
                    </Dropdown.Item>
                  </Dropdown.Menu>
              </Dropdown>
            <RippleEffect extraClassName="justify-content-end ms-xxl-1 ms-0">
              <CommonButton variant="danger" size="sm" className="rounded">
                <span
                >
                 Publish
                </span>
              </CommonButton>
            </RippleEffect> */}
              </div>
            </div>
          </Container>
        </Navbar>
      </header>
      <ModalComponent
        show={shareModal}
        size="md"
        title="Share Biography"
        closeButton="true"
        modalExtraClass="sharebiography"
        extraTitleClassName="sharebiography_title"
        onHandleCancel={handleCloseModal}
      >
        <div className="sharebiography_body">
          <ShareBiographyForm
            url={url}
            isCopy={isCopy}
            setIsCopy={setIsCopy}
            t={t}
          />
        </div>
        <WebShare Url={url} />
      </ModalComponent>
      <SweetAlert
        reverseButtons
        title={
          memorialData?.isSaved === true
            ? t("text.biographies.unSaveBiography")
            : t("text.biographies.saveBiography")
        }
        text={
          memorialData?.isSaved === true
            ? t("text.biographies.areYouSureUnSaveBiography")
            : t("text.biographies.areYouSureSaveBiography")
        }
        show={isAlertVisible}
        icon="question"
        showCancelButton
        setIsAlertVisible={setIsAlertVisible}
        onConfirmAlert={() => handleDelete(decoder(id))}
      />{" "}
      <SweetAlert
        text="Are you sure you want to publish?"
        show={publishAlert}
        icon="question"
        showCancelButton
        confirmButtonText="Publish Now"
        cancelButtonText="Cancel"
        setIsAlertVisible={setPublishAlert}
        onConfirmAlert={() => onPublish(publishedId)}
      />
    </>
  );
}

export default ThemeNavbar;
